import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    TextField,
} from "@material-ui/core";
import { Formik } from "formik";
import * as yup from "yup";
import React, { useCallback, useRef, useState } from "react";
import InputDatePicker from "../../../../components/InputDatePicker";
import TextareaApp from "../../../../components/TextareaApp";
import { TabPane, Tabs } from "react-bootstrap";
import UploadFileExel from "../../../../components/UploadFileExcel";
import { exportExcel, importExcel } from "../../../../../utils/xlsx";
import MaterialTable from "material-table";
import { optionTablesBroadcast } from "../helpers/broadcastOption";
import SelectSearchMulti from "../../../../components/SelectSearchMulti";

const initialValues = {
    message_title: "",
    message_body: "",
    target_audience: "0",
    broad_date: new Date(),
    hnNumberArray: [],
    userMobileIds: [],
};

const validationSchemaImportFile = yup.object({
    message_title: yup.string().required("Required"),
    message_body: yup.string().required("Required"),
    hnNumberArray: yup.array().min(1, "Required"),
});

const validationSchemaHN = yup.object({
    message_title: yup.string().required("Required"),
    message_body: yup.string().required("Required"),
    userMobileIds: yup.array().min(1, "Required"),
});

function FormAddBroad({ onSubmit = () => {}, onCancel = () => {}, userMobileOption = [] }) {
    const formikRef = useRef(null);
    const [targetAudience, setTargetAudience] = useState("0");
    const [excelFiles, setExcelFiles] = useState([]);
    const [excelData, setExcelData] = useState([]);

    const handleUploadExcelFiles = useCallback(
        async files => {
            setExcelFiles(files);
            const data = await importExcel(files[0]);
            if (!data?.filter(item => item?.HN)?.length) {
                formikRef.current.setFieldError("hnNumberArray", "No HN!!! Please Export Template.");
                return;
            }
            setExcelData(data);
            formikRef.current.setFieldValue(
                "hnNumberArray",
                data?.map(item => item?.HN),
            );
        },
        [formikRef],
    );

    const handleExportTemplate = useCallback(() => {
        exportExcel([{ HN: "53-021982" }, { HN: "53-034186" }, { HN: "61-002403" }], ["HN"], "HN_IMPORT");
    }, []);

    const handleRemoveExcel = useCallback(() => {
        setExcelFiles([]);
        setExcelData([]);
        formikRef.current.setFieldValue("hnNumberArray", []);
    }, [formikRef]);

    return (
        <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={targetAudience === "0" ? validationSchemaImportFile : validationSchemaHN}
            onSubmit={onSubmit}>
            {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
                <Grid container>
                    <Grid item xs={12}>
                        <FormControl className="t-form-group-custom mb-7" fullWidth>
                            <FormLabel className="text-dark mb-4">Message Title</FormLabel>
                            <TextField
                                id="message_title"
                                name="message_title"
                                variant="outlined"
                                size="small"
                                value={values.message_title}
                                onChange={handleChange}
                                error={Boolean(errors.message_title)}
                                helperText={errors.message_title}
                                FormHelperTextProps={{
                                    style: {
                                        marginLeft: 0,
                                    },
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl className="t-form-group-custom mb-7" fullWidth>
                            <FormLabel className="text-dark mb-4">Message Body</FormLabel>
                            <TextareaApp
                                props={{
                                    textAreaProps: {
                                        value: values?.message_body,
                                        onChange: handleChange,
                                        name: "message_body",
                                        rows: 5,
                                    },
                                }}
                                errorMessage={errors?.message_body}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl className="t-form-group-custom mb-7" fullWidth>
                            <FormLabel className="text-dark mb-4">Link</FormLabel>
                            <TextField
                                id="link_url"
                                name="link_url"
                                variant="outlined"
                                size="small"
                                value={values.link_url}
                                onChange={handleChange}
                                error={Boolean(errors.link_url)}
                                helperText={errors.link_url}
                                FormHelperTextProps={{
                                    style: {
                                        marginLeft: 0,
                                    },
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl className="t-form-group-custom border-bottom mb-5" fullWidth>
                            <FormLabel className="text-dark mb-4">Target audience</FormLabel>
                            <RadioGroup
                                className="flex-row"
                                name="target_audience"
                                value={values?.target_audience}
                                onChange={(_, value) => {
                                    setFieldValue("target_audience", value);
                                    setTargetAudience(value);
                                }}>
                                <FormControlLabel
                                    style={{ flex: 0.3 }}
                                    value="0"
                                    control={<Radio color="primary" />}
                                    label="Import File"
                                />
                                <FormControlLabel
                                    style={{ flex: 0.3 }}
                                    value="1"
                                    control={<Radio color="primary" />}
                                    label="ส่งโดยระบุหมายเลข HN"
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Tabs activeKey={values?.target_audience}>
                            <TabPane eventKey={0}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} lg={6}>
                                        <Box className="w-100">
                                            <FormLabel className="text-dark mb-4">Upload Excel File</FormLabel>
                                            <UploadFileExel
                                                previewExcelFiles={excelFiles}
                                                onAcceptedFiles={files => handleUploadExcelFiles(files)}
                                                removeAll={handleRemoveExcel}
                                                handleExportTemplate={handleExportTemplate}
                                                error={errors.hnNumberArray}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} lg={6}>
                                        <Box className="w-100">
                                            <FormLabel className="text-dark mb-4">Date</FormLabel>
                                            <InputDatePicker
                                                label=""
                                                className="mt-0 t-form-group-custom"
                                                value={values.broad_date}
                                                onChange={date => {
                                                    setFieldValue("broad_date", date);
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                    {excelData?.length ? (
                                        <Grid item xs={12} lg={12} className="mb-5">
                                            <MaterialTable
                                                title={""}
                                                components={{ Container: Box }}
                                                // isLoading={isLoading}
                                                // tableRef={tableRef}
                                                data={excelData}
                                                columns={[{ field: "HN", title: "HN" }]}
                                                options={optionTablesBroadcast}
                                            />
                                        </Grid>
                                    ) : null}
                                </Grid>
                            </TabPane>
                            <TabPane eventKey={1}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} lg={6}>
                                        <FormControl className="t-form-group-custom" fullWidth>
                                            <FormLabel className="text-dark">Add</FormLabel>
                                            <SelectSearchMulti
                                                options={userMobileOption}
                                                getOptionLabel={opt => opt?.hnNumber || "-"}
                                                getOptionValue={opt => opt?.usersMobileId}
                                                value={userMobileOption.filter(dt =>
                                                    values?.userMobileIds.includes(dt.usersMobileId),
                                                )}
                                                onChange={(vals = []) => {
                                                    const arrValues = vals.map(dt => dt?.usersMobileId);
                                                    setFieldValue("userMobileIds", arrValues);
                                                }}
                                                menuPosition="fixed"
                                                error={errors?.userMobileIds}
                                            />
                                            {/* <SelectMultiApp
                                                options={userMobileOption}
                                                value={values?.userMobileIds}
                                                onChange={evt => {
                                                    // console.log(evt.target.value);
                                                    setFieldValue("userMobileIds", evt.target.value);
                                                }}
                                                keyValue="usersMobileId"
                                                keyLabel="hnNumber"
                                                RenderOption={(option, idx) => (
                                                    <MenuItem key={`hn_${idx}`} value={option?.usersMobileId}>
                                                        {option?.hnNumber}
                                                    </MenuItem>
                                                )}
                                                error={errors?.userMobileIds}
                                            /> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={6}>
                                        <FormControl fullWidth>
                                            <FormLabel className="text-dark">Date</FormLabel>
                                            <InputDatePicker
                                                label=""
                                                className="mt-0 t-form-group-custom"
                                                value={values.broad_date}
                                                onChange={date => {
                                                    setFieldValue("broad_date", date);
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </TabPane>
                        </Tabs>
                    </Grid>

                    <Grid item xs={12}>
                        <div className="row justify-content-md-end">
                            <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                <Button onClick={handleSubmit} type="submit" className="w-100 btn t-btn-primary">
                                    บันทึก
                                </Button>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                <Button onClick={onCancel} type="submit" className="w-100 btn t-btn-gray">
                                    ยกเลิก
                                </Button>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            )}
        </Formik>
    );
}

export default FormAddBroad;
